<template>
  <g>
    <path
      d="M26.7538 22.0475H5.24267C4.70489 22.0475 4.26489 21.6075 4.26489 21.0697V7.38085C4.26489 6.84308 4.70489 6.40308 5.24267 6.40308H26.7538C27.2916 6.40308 27.7316 6.84308 27.7316 7.38085V21.0697C27.7316 21.6075 27.2916 22.0475 26.7538 22.0475ZM6.22045 20.092H25.776V8.35863H6.22045V20.092Z"
      :fill="iconColor"
    />
    <path
      d="M7.53676 18.6232V18.7732H7.68676H24.309H24.459V18.6232V9.82324V9.67324H24.309H7.68676H7.53676V9.82324V18.6232ZM24.7979 19.451H7.19787C7.00694 19.451 6.85898 19.3031 6.85898 19.1121V9.33435C6.85898 9.14341 7.00694 8.99546 7.19787 8.99546H24.7979C24.9888 8.99546 25.1368 9.14341 25.1368 9.33435V19.1121C25.1368 19.3011 24.981 19.451 24.7979 19.451Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.3"
    />
    <path
      d="M19.5983 26.4836H12.3921C11.8543 26.4836 11.4143 26.0436 11.4143 25.5059C11.4143 24.9681 11.8543 24.5281 12.3921 24.5281H19.5983C20.1361 24.5281 20.5761 24.9681 20.5761 25.5059C20.5761 26.0436 20.1361 26.4836 19.5983 26.4836Z"
      :fill="iconColor"
    />
    <path
      d="M13.5059 26.2009C12.9681 26.2009 12.5281 25.7609 12.5281 25.2232V21.2729C12.5281 20.7352 12.9681 20.2952 13.5059 20.2952C14.0436 20.2952 14.4836 20.7352 14.4836 21.2729V25.2232C14.4836 25.7609 14.0534 26.2009 13.5059 26.2009Z"
      :fill="iconColor"
    />
    <path
      d="M18.4834 26.2009C17.9456 26.2009 17.5056 25.7609 17.5056 25.2232V21.2729C17.5056 20.7352 17.9456 20.2952 18.4834 20.2952C19.0212 20.2952 19.4612 20.7352 19.4612 21.2729V25.2232C19.4612 25.7609 19.0212 26.2009 18.4834 26.2009Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
